import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-05e2341a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "contract-header"
}
const _hoisted_2 = { class: "right-area" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "icon-area" }
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "copied-message" }
const _hoisted_8 = {
  key: 0,
  class: "contract-area w-full"
}
const _hoisted_9 = { class: "item-name long-name w-full" }
const _hoisted_10 = { class: "item-content mt-2" }
const _hoisted_11 = { class: "paper" }
const _hoisted_12 = ["src"]
const _hoisted_13 = {
  key: 1,
  class: "contract-area w-full mt-1"
}
const _hoisted_14 = { class: "contract-item" }
const _hoisted_15 = { class: "item-content mt-2" }
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "signer-area mt-5" }
const _hoisted_18 = { class: "header-title mb-1" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))
const _hoisted_20 = { class: "signer-list" }
const _hoisted_21 = { class: "item" }
const _hoisted_22 = { class: "row-info" }
const _hoisted_23 = { class: "order-number" }
const _hoisted_24 = { class: "number" }
const _hoisted_25 = { class: "user-info ml-1" }
const _hoisted_26 = { class: "username-row" }
const _hoisted_27 = { class: "username" }
const _hoisted_28 = ["src"]
const _hoisted_29 = { class: "email" }
const _hoisted_30 = { class: "company-name" }
const _hoisted_31 = {
  key: 0,
  class: "company ml-1"
}
const _hoisted_32 = {
  key: 0,
  class: "status signed"
}
const _hoisted_33 = {
  key: 1,
  class: "status rejected"
}
const _hoisted_34 = {
  key: 2,
  class: "status"
}
const _hoisted_35 = { class: "header-title-row mt-5" }
const _hoisted_36 = { class: "title mt-1" }
const _hoisted_37 = ["src"]
const _hoisted_38 = { class: "header-title-row mt-5 security-section" }
const _hoisted_39 = { class: "title" }
const _hoisted_40 = { class: "w-full" }
const _hoisted_41 = { class: "protect-row" }
const _hoisted_42 = { class: "protect-row-leading" }
const _hoisted_43 = { class: "title" }
const _hoisted_44 = {
  key: 0,
  class: "state ml-1"
}
const _hoisted_45 = {
  key: 1,
  class: "state ml-1"
}
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "thin-divider" }, null, -1))
const _hoisted_47 = { class: "protect-row" }
const _hoisted_48 = { class: "protect-row-leading" }
const _hoisted_49 = { class: "title" }
const _hoisted_50 = {
  key: 0,
  class: "state ml-1"
}
const _hoisted_51 = {
  key: 1,
  class: "state ml-1"
}
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "thin-divider" }, null, -1))
const _hoisted_53 = { class: "protect-row" }
const _hoisted_54 = { class: "protect-row-leading" }
const _hoisted_55 = { class: "title" }
const _hoisted_56 = {
  key: 0,
  class: "state ml-1"
}
const _hoisted_57 = {
  key: 1,
  class: "state ml-1"
}
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "thin-divider" }, null, -1))
const _hoisted_59 = { class: "protect-row" }
const _hoisted_60 = { class: "protect-row-leading" }
const _hoisted_61 = { class: "title" }
const _hoisted_62 = {
  key: 0,
  class: "state ml-1"
}
const _hoisted_63 = {
  key: 1,
  class: "state ml-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderTitleBar = _resolveComponent("HeaderTitleBar")!
  const _component_TextButton = _resolveComponent("TextButton")!
  const _component_SideAccountVars = _resolveComponent("SideAccountVars")!
  const _component_PdfViewer = _resolveComponent("PdfViewer")!
  const _component_flat_button = _resolveComponent("flat-button")!
  const _component_FilePreview = _resolveComponent("FilePreview")!
  const _component_AvatarCircle = _resolveComponent("AvatarCircle")!
  const _component_ContractInformationReadonly = _resolveComponent("ContractInformationReadonly")!
  const _component_AfterLoginPageLayout = _resolveComponent("AfterLoginPageLayout")!

  return (_openBlock(), _createBlock(_component_AfterLoginPageLayout, {
    class: _normalizeClass(["sign-contract-done", { 'guest-sign-done': _ctx.isGuest }])
  }, {
    title: _withCtx(() => [
      (!_ctx.isGuest)
        ? (_openBlock(), _createBlock(_component_HeaderTitleBar, {
            key: 0,
            title: _ctx.contractState.title,
            "go-back-button-text": !_ctx.isMobile ? _ctx.$t('sign.returnToContract') : '',
            onOnBack: _ctx.navigateToFolder
          }, null, 8, ["title", "go-back-button-text", "onOnBack"]))
        : (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("p", null, _toDisplayString(_ctx.contractState.title), 1)
          ]))
    ]),
    bottomRight: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.isMobile && !_ctx.isGuest)
          ? (_openBlock(), _createBlock(_component_TextButton, {
              key: 0,
              text: _ctx.$t('sign.returnToContract'),
              icon: require('icons/prev-arrow.svg'),
              onOnClick: _ctx.navigateToFolder
            }, null, 8, ["text", "icon", "onOnClick"]))
          : _createCommentVNode("", true),
        _createVNode(_component_TextButton, {
          text: _ctx.$t('sign.batchDownload'),
          icon: require('icons/download.svg'),
          "disabled-icon": require('icons/download-grey.svg'),
          class: "button-group download-btn download-all",
          onOnClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.download(_ctx.getFilePathFromUrl(_ctx.contractState.zipSummaryPath)))),
          enabled: _ctx.isGuest || _ctx.contractState.canUpdate
        }, null, 8, ["text", "icon", "disabled-icon", "enabled"]),
        _createVNode(_component_TextButton, {
          text: _ctx.$t('sign.fileDownload'),
          icon: require('icons/download.svg'),
          "disabled-icon": require('icons/download-grey.svg'),
          class: "button-group download-btn",
          onOnClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.download(_ctx.getFilePathFromUrl(_ctx.contractState.zipFilePath)))),
          enabled: _ctx.isGuest || _ctx.contractState.canUpdate
        }, null, 8, ["text", "icon", "disabled-icon", "enabled"]),
        _createVNode(_component_TextButton, {
          text: _ctx.$t('sign.signingCertificateDownload'),
          icon: require('icons/download.svg'),
          "disabled-icon": require('icons/download-grey.svg'),
          class: "button-group download-btn",
          onOnClick: _cache[2] || (_cache[2] = ($event: any) => (
            _ctx.download(_ctx.getFilePathFromUrl(_ctx.contractState.signatureInformationPath))
          )),
          enabled: _ctx.isGuest || _ctx.contractState.canUpdate
        }, null, 8, ["text", "icon", "disabled-icon", "enabled"]),
        (!_ctx.isMobile)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("span", {
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.downloadCsv()))
                }, [
                  _createElementVNode("img", {
                    class: "icon",
                    src: require('icons/download-black.svg')
                  }, null, 8, _hoisted_5)
                ]),
                _createElementVNode("span", {
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.copyToClipboard()))
                }, [
                  _withDirectives(_createElementVNode("img", {
                    class: "icon",
                    src: require('icons/content_copy.svg')
                  }, null, 8, _hoisted_6), [
                    [_vShow, !_ctx.isCopied]
                  ]),
                  _withDirectives(_createElementVNode("p", _hoisted_7, "Copied!", 512), [
                    [_vShow, _ctx.isCopied]
                  ])
                ])
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fileData, (file, index) => {
                return (_openBlock(), _createElementBlock("div", { key: index }, [
                  _createVNode(_component_SideAccountVars, {
                    components: file.accountVars,
                    "contract-name": file.fileName,
                    class: "mb-2"
                  }, null, 8, ["components", "contract-name"])
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    bottomLeft: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["w-full border-inner", { 'mt-3': !_ctx.isGuest && !_ctx.isMobile }])
      }, [
        (!_ctx.isMobile)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.files, (file) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: file.id,
                  class: "contract-item"
                }, [
                  _createElementVNode("p", _hoisted_9, _toDisplayString(file.name), 1),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_component_PdfViewer, {
                        "file-id": file.id,
                        src: file.path,
                        page: 1
                      }, null, 8, ["file-id", "src"])
                    ]),
                    (_ctx.isAllSigned)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          class: "icon-check",
                          src: require('icons/check-mark-green.svg'),
                          alt: "icon check"
                        }, null, 8, _hoisted_12))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode(_component_flat_button, {
                    text: _ctx.$t('sign.denote'),
                    class: "w-full mt-2 item-btn",
                    onOnClick: ($event: any) => (_ctx.download(file.path)),
                    enabled: _ctx.isGuest || _ctx.canContractInformationUpdate
                  }, null, 8, ["text", "onOnClick", "enabled"])
                ]))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_FilePreview, {
                    class: "mobile-preview",
                    files: _ctx.files,
                    "onUpdate:files": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.files) = $event)),
                    selectedIdx: _ctx.selectedFileIndex,
                    "onUpdate:selectedIdx": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedFileIndex) = $event)),
                    "is-padding": false,
                    "is-scale": true,
                    "can-remove": false
                  }, null, 8, ["files", "selectedIdx"]),
                  (_ctx.isAllSigned)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        class: "icon-check",
                        src: require('icons/check-mark-green.svg'),
                        alt: "icon check"
                      }, null, 8, _hoisted_16))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(_component_flat_button, {
                  onOnClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.download(_ctx.files[_ctx.selectedFileIndex].path))),
                  class: "download-btn",
                  text: _ctx.$t('common.download')
                }, null, 8, ["text"])
              ])
            ])),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.$t("contractGuest.signerListTitle")), 1),
          _hoisted_19,
          _createElementVNode("div", _hoisted_20, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contractState.contractSigners, (user) => {
              return (_openBlock(), _createElementBlock("div", {
                key: user.id,
                class: "signer-item"
              }, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("p", _hoisted_24, _toDisplayString(user.order), 1)
                    ]),
                    _createVNode(_component_AvatarCircle, {
                      class: "ml-1 avatar",
                      avatar: 
                      user.profilePicture
                        ? _ctx.getFilePathFromUrl(user.profilePicture)
                        : require('icons/default-avatar.svg')
                    ,
                      alt: "avatar"
                    }, null, 8, ["avatar"]),
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("p", _hoisted_27, _toDisplayString(user.signerLastName) + " " + _toDisplayString(user.signerFirstName), 1),
                        (user.signerAccessCode)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              class: "icon-key ml-1",
                              src: require('icons/key.svg'),
                              alt: "icon key"
                            }, null, 8, _hoisted_28))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("p", _hoisted_29, _toDisplayString(user.signerEmail), 1)
                    ]),
                    _createElementVNode("div", _hoisted_30, [
                      (user.signerCompanyName && !_ctx.isMobile)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_31, _toDisplayString(user.signerCompanyName), 1))
                        : _createCommentVNode("", true)
                    ]),
                    (user.statusName == 'signed')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_32, _toDisplayString(_ctx.$t("sign.signed")), 1))
                      : (user.statusName == 'rejected')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_33, _toDisplayString(_ctx.$t("sign.rejected")), 1))
                        : (_openBlock(), _createElementBlock("div", _hoisted_34, _toDisplayString(_ctx.$t("sign.signed")), 1))
                  ])
                ])
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_35, [
          _createElementVNode("p", _hoisted_36, _toDisplayString(_ctx.$t("contract.advancedOption")), 1),
          _createElementVNode("img", {
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.isShowAdvanced = !_ctx.isShowAdvanced)),
            class: _normalizeClass(["mt-1 expand-icon", { expanded: !_ctx.isShowAdvanced }]),
            src: require('icons/icon_dropdown.svg'),
            alt: "dropdown icon"
          }, null, 10, _hoisted_37)
        ]),
        _withDirectives(_createVNode(_component_ContractInformationReadonly, {
          contractPartnerName: _ctx.contractState.contractPartnerName,
          contractInformation: _ctx.contractDetailInfo,
          contractCustomFields: _ctx.contractState.contractCustomFields
        }, null, 8, ["contractPartnerName", "contractInformation", "contractCustomFields"]), [
          [_vShow, _ctx.isShowAdvanced]
        ]),
        _createElementVNode("div", _hoisted_38, [
          _createElementVNode("p", _hoisted_39, _toDisplayString(_ctx.$t("templateSigner.protectSection")), 1)
        ]),
        _createElementVNode("div", _hoisted_40, [
          _createElementVNode("div", _hoisted_41, [
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("p", _hoisted_43, _toDisplayString(_ctx.$t("templateSigner.requireXIDSign")), 1),
              (_ctx.contractState.isXIDRequired)
                ? (_openBlock(), _createElementBlock("p", _hoisted_44, _toDisplayString(_ctx.$t("templateSigner.on")), 1))
                : (_openBlock(), _createElementBlock("p", _hoisted_45, _toDisplayString(_ctx.$t("templateSigner.off")), 1))
            ])
          ]),
          _hoisted_46,
          _createElementVNode("div", _hoisted_47, [
            _createElementVNode("div", _hoisted_48, [
              _createElementVNode("p", _hoisted_49, _toDisplayString(_ctx.$t("templateSigner.requireTwoFactor")), 1),
              (_ctx.contractState.is2FARequired)
                ? (_openBlock(), _createElementBlock("p", _hoisted_50, _toDisplayString(_ctx.$t("templateSigner.on")), 1))
                : (_openBlock(), _createElementBlock("p", _hoisted_51, _toDisplayString(_ctx.$t("templateSigner.off")), 1))
            ])
          ]),
          _hoisted_52,
          _createElementVNode("div", _hoisted_53, [
            _createElementVNode("div", _hoisted_54, [
              _createElementVNode("p", _hoisted_55, _toDisplayString(_ctx.$t("templateSigner.allowTransfer")), 1),
              (_ctx.contractState.isSignerTransferAllowed)
                ? (_openBlock(), _createElementBlock("p", _hoisted_56, _toDisplayString(_ctx.$t("templateSigner.on")), 1))
                : (_openBlock(), _createElementBlock("p", _hoisted_57, _toDisplayString(_ctx.$t("templateSigner.off")), 1))
            ])
          ]),
          _hoisted_58,
          _createElementVNode("div", _hoisted_59, [
            _createElementVNode("div", _hoisted_60, [
              _createElementVNode("p", _hoisted_61, _toDisplayString(_ctx.$t("templateSigner.needTimeStamp")), 1),
              (_ctx.contractState.needTimeStamp)
                ? (_openBlock(), _createElementBlock("p", _hoisted_62, _toDisplayString(_ctx.$t("templateSigner.on")), 1))
                : (_openBlock(), _createElementBlock("p", _hoisted_63, _toDisplayString(_ctx.$t("templateSigner.off")), 1))
            ])
          ])
        ])
      ], 2)
    ]),
    _: 1
  }, 8, ["class"]))
}